module.exports = __webpack_public_path__ + "img/keno_ball_all.6b93177b.png";